export const FETCH_ME = 'FETCH_ME';
export const FETCH_ME_START = `${FETCH_ME}_START`;
export const FETCH_ME_SUCCESS = `${FETCH_ME}_SUCCESS`;
export const FETCH_ME_ERROR = `${FETCH_ME}_ERROR`;
export const UPDATE_ME = 'UPDATE_ME';
export const UPDATE_ME_START = `${UPDATE_ME}_START`;
export const UPDATE_ME_SUCCESS = `${UPDATE_ME}_SUCCESS`;
export const UPDATE_ME_ERROR = `${UPDATE_ME}_ERROR`;
//# sourceMappingURL=actionTypes.js.map